/**
 * Resolve a display title for an item record.
 *
 * Priority: name → keyedName (only when different from itemNumber)
 *   → displayName → fullName → className → itemNumber
 */
export function getItemTitle(
  record: Record<string, unknown> | undefined,
  fallback?: string
): string | undefined {
  if (!record) return fallback;

  const name = record.name as string | undefined;
  if (name) return name;

  const keyedName = record.keyedName as string | undefined;
  const itemNumber = record.itemNumber as string | undefined;

  // keyedName is useful only when it carries more info than itemNumber
  if (keyedName && keyedName !== itemNumber) return keyedName;

  const displayName = record.displayName as string | undefined;
  if (displayName) return displayName;

  const fullName = record.fullName as string | undefined;
  if (fullName) return fullName;

  const className = record.className as string | undefined;
  if (className) return className;

  if (itemNumber) return itemNumber;

  return fallback;
}
